import api from './api';

class FestivalsService {
  // Get all festivals
  async getAllFestivals() {
    try {
      const response = await api.get('/festivals');
      return response.data;
    } catch (error) {
      console.error('Error fetching festivals:', error);
      throw error;
    }
  }

  // Get upcoming festivals
  async getUpcomingFestivals() {
    try {
      const response = await api.get('/festivals/upcoming');
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming festivals:', error);
      throw error;
    }
  }

  // Get festival calendar for a year
  async getFestivalCalendar(year) {
    try {
      const response = await api.get(`/festivals/calendar/${year}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching festival calendar:', error);
      throw error;
    }
  }

  // Get festivals by month
  async getFestivalsByMonth(month, year) {
    try {
      const response = await api.get('/festivals/month', {
        params: { month, year },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching festivals by month:', error);
      throw error;
    }
  }

  // Search festivals by name
  async searchFestivals(name) {
    try {
      const response = await api.get('/festivals/search', {
        params: { name },
      });
      return response.data;
    } catch (error) {
      console.error('Error searching festivals:', error);
      throw error;
    }
  }

  // Get festival by ID
  async getFestivalById(id) {
    try {
      const response = await api.get(`/festivals/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching festival:', error);
      throw error;
    }
  }

  // Create festival (admin only)
  async createFestival(festivalData) {
    try {
      const response = await api.post('/festivals', festivalData);
      return response.data;
    } catch (error) {
      console.error('Error creating festival:', error);
      throw error;
    }
  }

  // Update festival (admin only)
  async updateFestival(id, festivalData) {
    try {
      const response = await api.patch(`/festivals/${id}`, festivalData);
      return response.data;
    } catch (error) {
      console.error('Error updating festival:', error);
      throw error;
    }
  }

  // Delete festival (admin only)
  async deleteFestival(id) {
    try {
      const response = await api.delete(`/festivals/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting festival:', error);
      throw error;
    }
  }
}

const festivalsService = new FestivalsService();
export default festivalsService;
